import { React, useEffect, useState,useReducer ,useRef,memo} from 'react'
import { motion, AnimatePresence, delay } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import PortalComponents from '../../components/PortalComponents/PortalComponents';
import profpic from "../../Images/profpic.jpeg"
import { Button } from "@nextui-org/react";
import { Avatar } from "@nextui-org/react";
import '../CustomerPortal.css'
import axios from 'axios';
import BackEndUrl from '../../backURL';
import loading from '../../Images/three-dots.svg'



const backend = BackEndUrl.domain
const Account = ({setProfPic,prof_pic_url,toast,setcusProfileName}) => {
    
    async function GetData(){
            
        try{
            
            const response = await axios.post(backend+"/profile-data",{
                nic:sessionStorage.getItem("nic"),
                mobile:sessionStorage.getItem("mobile")
            },{
                headers: {
                    Authorization: sessionStorage.getItem('token'),
                }
            })
         
            setdata(response.data[0])
            setProfPic(response.data[0].profile_pic)
            dispatch({type:"fname",payload:{value:response.data[0].fname}})
            dispatch({type:"lname",payload:{value:response.data[0].lname}})
            dispatch({type:"passport",payload:{value:response.data[0].passport}})
            dispatch({type:"email",payload:{value:response.data[0].email}})
            sessionStorage.setItem("full_name",response.data[0].full_name)
                   
        }
        catch(err){
            console.error(err)
        }
    }
    function reducer(state,action){
       
      return {
        ...state,
        [action.type]:action.payload.value
      }
    }
   const [state,dispatch]=useReducer(reducer,{
    
    fname:null,
    lname:null,
    email:null,
    passport:null

   })
    const [ ProfPicFile, setProfPicFile] = useState(null); 
    const[data,setdata]= useState(null)
    useEffect(() => {
        async function GetData(){
            
            try{
                
                const response = await axios.post(backend+"/profile-data",{
                    nic:sessionStorage.getItem("nic"),
                    mobile:sessionStorage.getItem("mobile")
                },{
                    headers: {
                        Authorization: sessionStorage.getItem('token'),
                    }
                })
             
                setdata(response.data[0])
                setProfPic(response.data[0].profile_pic)
                dispatch({type:"fname",payload:{value:response.data[0].fname}})
                dispatch({type:"lname",payload:{value:response.data[0].lname}})
                dispatch({type:"passport",payload:{value:response.data[0].passport}})
                dispatch({type:"email",payload:{value:response.data[0].email}})


            }
            catch(err){
                console.error(err)
            }
        }
        if (ProfPicFile) {
            UploadPic();
        }
        
        if(!data){
            GetData();
        }
    }, [ProfPicFile]);

    async function UploadPic() {
        try {
            const form = new FormData();
         
            form.append("prof_pic", ProfPicFile);
            form.append("nic", sessionStorage.getItem("nic"));
            form.append("mobile", sessionStorage.getItem("mobile"));
            form.append("prev_loc", prof_pic_url);

            const response = await axios.post(backend + "/update-prof-pic", form, {
                headers: {
                    Authorization: sessionStorage.getItem('token'),
                },
            });

           
            setProfPic(response.data)
            setProfPic(response.data)
        } catch (err) {
            console.error(err);
        }
    }
    async function UpdateAccount() {
        try {
           
            const response = await axios.post(backend + "/profile-update",{
                email:state.email,
                mobile:sessionStorage.getItem("mobile"),
                nic:sessionStorage.getItem("nic"),
                fname:state.fname,
                lname:state.lname


            }, {
                headers: {
                    Authorization: sessionStorage.getItem('token'),
                },
            });
   
           
          
            if (response.status=="200"){
                await GetData()
                setcusProfileName(sessionStorage.getItem("full_name"))
                toast.current.clear();
                toast.current.show({
                  severity: 'success',
                  summary: 'Saved',
                                       
                  life: 3000,
                  sticky: false,
                  content: (props) => (
                    <div className="p-3" style={{ flex: '1' }}>
                        <div className="" style={{fontSize:"2.5dvh"}}>{props.message.summary}</div>                  
                        <div className=""  style={{fontSize:"2dvh"}}>{props.message.description}</div>                  
                    </div>
                  ),
                });
              
                
            }

           
           
        } catch (err) {
            console.error(err);
        }
    }

    const handleEditButtonClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleFileChange = (e) => {
      
        const file = e.target.files[0];
        setProfPicFile(file);
       
    };
    
       
    
       
    if(data)
   
 { return (
    <motion.div
    initial={{
        y: "30%",
        opacity: 0
    }}
    animate={{
        y: "0%",
        opacity: 1,
        transition: { duration: 0.3 }
    }}
>

    <Row style={{ height: "30vh" }} className='d-flex justify-content-center'>
   

        <Col xs={11} className='d-flex justify-content-center align-items-center' >
            <div className='avatar-container'>
               
          
           <Avatar className='avatar-image' src={prof_pic_url ? backend + prof_pic_url : null} style={{ height: "150px", width: "150px" }} />
            <Button  onClick={handleEditButtonClick} isIconOnly className='prof-pic-edit-btn'>
               <FontAwesomeIcon icon={faPenToSquare} color='white'/>
            </Button>
            <input
            type="file"
            id="fileInput"
            name="prof-pic"
            onChange={handleFileChange}
            style={{ display: 'none' }} 
            />
            </div>
            <div className='d-flex align-items-center '>
                <div style={{ height: "100%" }} className='d-flex align-items-center flex-column mx-5'>
                    <p style={{ fontSize: "20px" }}>{sessionStorage.getItem("full_name")}</p>
                    <p>Srilanka</p>
                </div>
            </div>

        </Col>



    </Row>
    <Row style={{ height: "50vh" }} className='d-flex justify-content-center'>
        <Col xs={10}>
            <Row>
                <Col xs={6}>
                    <PortalComponents
                        type={"input"}
                        label={"First Name"}
                        value={state.fname}
                        onchange={(e)=>{
                            dispatch({type:"fname",payload:{
                                value:e.target.value
                            }})
                        }}
                    />

                </Col>
                <Col xs={6}>

                    <PortalComponents
                        type={"input"}
                        label={"Last Name"}
                        value={state.lname}
                        onchange={(e)=>{
                            dispatch({type:"lname",payload:{
                                value:e.target.value
                            }})
                        }}
                    />
                </Col>
            </Row>
            
            <Row className='my-2'>
                <Col xs={12}>
                    <PortalComponents
                        type={"input"}
                        label={"Email"}
                        value={state.email}
                        onchange={(e)=>{
                            dispatch({type:"email",payload:{
                                value:e.target.value
                            }})
                        }}
                    />

                </Col>
               
            </Row>
            <Row className='my-5 d-flex justify-content-center'>
                <Col lg={2} md={2} sm={12} xs={12} className='d-flex justify-content-center '>
                    <Button style={{ backgroundColor: "#3468C0", height: "6vh", color:"white" }} onClick={()=>{UpdateAccount()}}>
                        Save Changes
                    </Button>
                </Col>
            </Row>
        </Col>

    </Row>
</motion.div>
  )}else{

 <Row style={{height:"70vh"}}>
    <img src={loading} className='m-5' style={{ width: "40%" }} />
  </Row>
  }
}

export default Account
